<template>
  <div class="mobileLgWrap_he">
    <van-nav-bar
      class="userNavBar"
      @click-left="onClickLeft"
      title="实名认证"
      left-arrow
    >
      <template #left>
        <van-icon name="../../../static/images/mobile/back.png" size="18" />
      </template>
    </van-nav-bar>
    <div class="loginMain_he">
      <form>
        <van-cell-group>
          <van-field
            :value="this.$sessionStore.getRealName()"
            v-model="realName"
            placeholder="请输入姓名"
            type="text"
            name="mobile"
            clearable
            label-align="left"
            @input="changColor"
          />
          <div class="bd_he">
            <van-field
              :value="this.$sessionStore.getIdcard()"
              v-model="idCard"
              placeholder="请输入身份证号码"
              type="text"
              name="identity"
              clearable
              label-align="left"
            >
            </van-field>
          </div>
          <div
            :class="phoneNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he'"
            @click="nextStep()"
          >
            <span><a href="javascript:;">下一步</a></span>
          </div>
        </van-cell-group>
      </form>
    </div>
  </div>
</template>
 
<script>
import md5 from "js-md5";
export default {
  data() {
    return {
      realName: "",
      idCard: "",
      phoneNum: "",
      type: localStorage.getItem("type"),
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    changColor(e) {
      this.phoneNum = e.length;
    },
    nextStep() {
      localStorage.setItem("realName", this.realName);
      localStorage.setItem("idCard", this.idCard);
      if (this.type == 2) {
        this.$router.push({
          path: "/mobileFaceVerification",
        });
      } else {
        this.$router.push({
          path: "/mobileCertificateUpload",
        });
      } 
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style >
.userNavBar .van-nav-bar__title {
  font-weight: 600;
}
</style>
<style scoped>
.userNavBar {
  width: 100%;
  margin-top: 0.133333rem;
}
.mobileLgWrap_he {
  background: none;
}
.van-cell,
.van-cell-group {
  background: none;
}
.van-cell {
  background: none;
}
.van-icon-eye-o::before {
  color: #6d7174;
}
.van-cell::after {
  border: none;
}
.van-cell {
  border-bottom: 1px solid #dfdede;
  margin-bottom: 0.72rem;
}
[class*="van-hairline"]::after {
  border: none;
}
/* .van-icon-eye-o::before {
} */
.budgeMobileInput {
  width: 6.933333rem;
}
.senMsg {
  display: inline-block;
  padding: 0.066667rem 0.133333rem;
  margin: 0.066667rem 0;
  color: #ffffff;
  border-radius: 0.106667rem;
  font-size: 0.16rem;
  position: absolute;
  right: 0.32rem;
  top: 0.08rem;
}
.bd_he {
  position: relative;
}
.budgeMobileDia {
  width: 5.093333rem;
}
.van-field {
  padding: 0.213333rem 0 0.213333rem 0;
}
.userLoginTitle_he {
  margin-top: 1rem;
}
</style>


// WEBPACK FOOTER //
// MobileAuthenticationFirst.vue?8287e496